// src/components/ServicesSection.jsx
import React from "react";
import "./ServicesSection.css";
/* ⇢ Imágenes */
import dashRoutines  from "../assets/images/dashboard-screenshots/dashboard-routines.png";
import dashDiets     from "../assets/images/dashboard-screenshots/dashboard-diets-options.png";
import dashProgress  from "../assets/images/dashboard-screenshots/dashboard-progress-top.png";
/* ⇢ Iconos Remix Icon */
import {
  RiCalendar2Line,  RiFileCopy2Line, RiBarChart2Line,
  RiScales2Line,    RiPieChart2Line,  RiLineChartLine
} from "react-icons/ri";

/* =========   CONFIG  ========= */
const services = [
  {
    title: "Entrenamiento",
    subtitle: "Planifica y asigna rutinas personalizadas",
    desktopImg: dashRoutines,
    features: [
      { icon: () => <span className="material-symbols-outlined svc-icon-smd">exercise</span>,
        title: "Ejercicios Propios",
        desc : "Crea ejercicios con tus vídeos para que los clientes los vean en la aplicación móvil." },
      { icon: RiCalendar2Line,
        title: "Rutinas Personalizadas",
        desc : "Arrastra los ejercicios al calendario de cada cliente y ordena y configura su rutina de forma visual." },
      { icon: RiFileCopy2Line,
        title: "Herramientas",
        desc : "Copia diaria y semanalmente las rutinas para un cliente y entre clientes para agilizar al máximo tu trabajo." },
    ],
  },
  {
    title      : "Nutrición",
    subtitle   : "Crea planes de nutrición a medida",
    desktopImg : dashDiets,
    features   : [
      { icon: () => <span className="material-symbols-outlined svc-icon-smd">restaurant</span>,
        title: "Dietas Personalizadas",
        desc : "Diseña dietas por opciones o semanales adaptadas a cada cliente." },
      { icon: RiBarChart2Line,
        title: "Parámetros",
        desc : "Define las calorías, macros e instrucciones para un control preciso." },
      { icon: () => <span className="material-symbols-outlined svc-icon-smd">assignment</span>,
        title: "Ajusta y Asigna",
        desc : "Modifica comidas y cantidades y asigna la dieta en un clic cuando esté lista." },
    ],
  },
  {
    title      : "Progreso",
    subtitle   : "Analiza métricas y evolución de tus clientes",
    desktopImg : dashProgress,
    features   : [
      { icon: RiScales2Line,
        title: "Peso Corporal",
        desc : "Establece un objetivo de peso y analiza la evolución que tu cliente registra en la app." },
      { icon: RiPieChart2Line,
        title: "Cumplimiento",
        desc : "Consulta el grado de cumplimiento semanal y mensual de cada cliente y su racha de días consecutivos." },
      { icon: RiLineChartLine,
        title: "Métricas",
        desc : "Sigue la evolución de la dieta asignada y la progresión en cada ejercicio para detectar estancamientos al instante." },
    ],
  },
];

/* =========   COMPONENTE  ========= */
export default function ServicesSection() {
  return (
    <section id="services" className="services-section pt-50 pb-50">
      <div className="container px-2 px-xl-0">

        {/* ────────────── Cabecera ────────────── */}
        <header className="hero-header text-center mb-20 mt-20 mb-lg-7">
          <span className="sub-title sub-title-with-margin-bottom text-black d-inline-block mb-10 wow fadeInUp delay-0-1s">
            Servicios
          </span>

          <div className="hero-bg" />

          {/* <h3
            className="hero-title wow animate__animated animate__fadeInUp"
            data-wow-delay="0.1s"
            data-wow-duration="1s"
          >
            Lleva tu Entrenamiento Personal<br /> al&nbsp;
            <span className="gradient-text">Siguiente Nivel</span>
          </h3> */}

          <h1
            className="title-services section-hook hero-title wow animate__animated animate__fadeInUp"
            data-wow-delay="0.12s"
            data-wow-duration="1s"
          >
            <span>Lleva tu entrenamiento personal<br/><span className="gradient-text"> al siguiente nivel</span></span>
          </h1>
        </header>
        <h2
          className="hero-sub-services mb-50 wow animate__animated animate__fadeInUp"
          data-wow-delay="0.25s"
          data-wow-duration="1s"
        >
          Mejora tu servicio y fideliza más clientes utilizando una aplicación para entrenadores personales todo-en-uno.
        </h2>

        {/* ────────────── Bloques dinámicos ────────────── */}
        {services.map((s, idx) => {
          const imgAnim  =
            idx % 2 === 0
              ? "wow animate__animated animate__fadeInRightShort"
              : "wow animate__animated animate__fadeInLeftShort";

          const featAnim =
            idx % 2 === 0
              ? "wow animate__animated animate__fadeInLeftShort"
              : "wow animate__animated animate__fadeInRightShort";

          const blockClass = [
            "service-block",
            idx === 0 ? "svc-block--white  svc-block--left"  : "",
            idx === 1 ? "svc-block--dark   svc-block--right" : "",
            idx === 2 ? "svc-block--white  svc-block--left"  : "",
          ].join(" ");

          return (
            <div key={s.title} className={`row ${blockClass} align-items-center gx-5 gy-4`}>
              {/* Elipse decorativa */}
              <span
                className="
                  svc-hero-shape
                  wow              /* activa WOW */
                  animate__animated
                  animate__fadeIn  /* sólo opacidad */
                "
                data-wow-delay="0s"      /* opcional */
                data-wow-duration="0.15s"      /* opcional */
                aria-hidden="true"
              />

              {/* ── Imagen (izq/dcha alterno) ── */}
              <div className={`col-lg-9 ${idx % 2 ? "" : "order-lg-2"}`}>
                <img
                  src={s.desktopImg}
                  alt={s.title}
                  className={`img-fluid rounded-4 shadow-lg service-media ${imgAnim}`}
                  data-wow-delay="0.15s"
                  data-wow-duration="1s"
                />
              </div>

              {/* ── Texto + features ── */}
              <div
                className={`
                  col-lg-3 pr-lg-4 service-text d-flex flex-column
                  ${idx % 2 ? "order-lg-1" : ""}
                `}
              >
                <h3
                  className="modern-title wow animate__animated animate__fadeInUp"
                  data-wow-delay="0.05s"
                  data-wow-duration="1s"
                >
                  {s.title}
                </h3>

                <ul className="svc-feature-list">
                  {s.features.map(({ icon: Icon, title, desc }, i) => (
                    <li
                      key={title}
                      className={`svc-feature-item ${featAnim}`}
                      data-wow-delay={`${0.2 + i * 0.1}s`}
                      data-wow-duration="1s"
                    >
                      <span className="svc-feat-icon svc-icon-smd"><Icon /></span>

                      <div className="svc-text-wrap">
                        <h4 className="svc-feature-title">{title}</h4>
                        <p  className="svc-feature-desc">{desc}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
